import React, { useEffect, useState, useMemo } from "react";
import { useNavigate, useParams, useLocation, Link as RouterLink, Link, redirect } from "react-router-dom";
import axios from "axios";
import { Container, Typography, FormGroup, Box, FormControlLabel, Button, Modal, Checkbox, Radio, TextField, FormControl, RadioGroup, Dialog, DialogTitle, DialogContent, List, ListItem, ListItemText } from '@mui/material';
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { createRoot } from "react-dom/client";
import api from "./api";
import Comp3Sub from "./Comp3Sub";
import Comp4Sub from "./Comp4Sub";
import Comp7Sub from "./Comp7Sub";
import Comp8Sub from "./Comp8Sub";
import Comp9Sub from "./Comp9Sub";
import Comp10Sub from "./Comp10Sub";
import Comp10_2Sub from "./Comp10_2Sub.js";
import Comp12Sub from "./Comp12Sub";
import Comp13Sub from "./Comp13Sub";
import Comp3PDF from "./Comp3PDF.js";
import Comp4PDF from "./Comp4PDF.js";
import Comp7PDF from "./Comp7PDF.js";
import Comp8PDF from "./Comp8PDF.js";
import Comp9PDF from "./Comp9PDF.js";
import Comp10PDF from "./Comp10PDF.js";
import Comp10_2PDF from "./Comp10_2PDF.js";
import Comp12PDF from "./Comp12PDF.js";
import Comp13PDF from "./Comp13PDF.js";
import FormRequire from "./FormRequire";
import Comp6Sub from "./Comp6Sub.js";
import Comp5Sub from "./Comp5Sub.js";
import FormRequirePDF from "./FormRequirePDF";
import FormElectricityPDF from "./FormElectricityPDF.js";
import JSZip from "jszip";
import Header from "./components/Header.jsx";
import { useConfirmBackLogout } from "./common/useConfirmBackLogout.js";
import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';

  const ContractorMypage = (isCarpetSelectedViaLease ,setIsCarpetSelectedViaLease, isCarpetSelectedViaPackage, setIsCarpetSelectedViaPackage) => {
    const { representativeId } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const currentPath = location.pathname;
    const [fetchedData, setFetchedData] = useState({});
    const [loading, setLoading] = useState(true);
    const [checkedPdfIds, setCheckedPdfIds] = useState([]);
    const [exhibitorStatuses, setExhibitorStatuses] = useState([]);
    const [corporateStatuses, setCorporateStatuses] = useState([]);
    const [companyNameFilter, setCompanyNameFilter] = useState("");
    const [contractorId, setContractorId] = useState(null);
    const [itemList, setItemList] = useState([]);
    const [pcItemList, setPcItemList] = useState([]);
    const [notices, setNotices] = useState([]);
    const noticesPerPage = 5;
    const [page, setPage] = useState(1);
    const [totalN, setTotal] = useState(0);
    const [latestHistoryMap, setLatestHistoryMap] = useState({});
    
    const [selectedFormKey, setSelectedFormKey] = useState(null);
    const [selectedExhibitorId, setSelectedExhibitorId] = useState(null);
    const [formModalOpen, setFormModalOpen] = useState(false);
    const [changeModalOpen, setChangeModalOpen] = useState(false);
    const [checked, setChecked] = useState({
      pack: false,
      storage: false,
      iphone: false,
      add: false,
    });
    const [gasChecked, setGasChecked] = useState({
      water: false,
      air: false,
      gas: false,
    });
    const [cleanChecked, setCleanChecked] = useState({
      garbage: false,
      oil: false,
      clean: false,
    });
    const [elecChecked, setElecChecked] = useState({
        v100: false,
        v200: false,
    });
    const [selectedPlans, setSelectedPlans] = useState([]);

    const [rentalItems, setRentalItems] = useState([]);

    useEffect(() => {
        const fetchItems = async () => {
            try {
                const res = await api.get("/api/master/items-o9");
                setRentalItems(res.data || []);
            } catch (err) {
                console.error("アイテム取得エラー:", err);
            }
        };
        fetchItems();
    }, []);

    const [pcItems, setPcItems] = useState([]);

    useEffect(() => {
        const fetchItems = async () => {
            try {
                const res = await api.get("/api/master/items-o10");
                setPcItems(res.data || []);
            } catch (err) {
                console.error("アイテム取得エラー:", err);
            }
        };
        fetchItems();
    }, []);

    const [elecItems, setElecItems] = useState([]);
    useEffect(() => {
          const fetchItems = async () => {
              try {
                  const res = await api.get("/api/master/items");
                  setElecItems(res.data || []);
              } catch (err) {
                  console.error("アイテム取得エラー:", err);
              }
          };
          fetchItems();
      }, []);

    const FIELD_CONFIGS = [
      {
        key: 'r1',
        label: '必須書類',
        category: 1,
      },
      {
        key: 'o3',
        label: '運送・会場内荷役',
        category: 3,
      },
      {
        key: 'o4',
        label: '床面工事',
        category: 4,
      },
      {
        key: 'o5',
        label: '電気使用',
        category: 5,
      },
      {
        key: 'o6',
        label: '電気備品',
        category: 6,
      },
      {
        key: 'o7',
        label: '給排水・エア・ガス',
        category: 7,
      },
      {
        key: 'o8',
        label: 'パッケージ装飾等',
        category: 8,
      },
      {
        key: 'o9',
        label: '装飾備品レンタル',
        category: 9,
      },
      {
        key: 'o10',
        label: 'PC・ソフトレンタル',
        category: 10,
      },
      {
        key: 'o10_2',
        label: 'インターネット接続',
        category: 14,
      },
      {
        key: 'o12',
        label: 'ゴミ・廃材・廃油処理',
        category: 12,
      },
      {
        key: 'o13',
        label: 'ブース平面図',
        category: 13,
      },
    ];

    const [statusSummary, setStatusSummary] = useState({
      total_exhibitors: 0,
      required_status: { count: 0, company_names: [], complete_count: 0, complete_company_names: [], no_count: 0, no_company_names: [] },
      o5_status: {
        count: 0,
        company_names: [],
        complete_count: 0,
        complete_company_names: [],
        no_count: 0,
        no_company_names: [],
        not_apply_count: 0,
        not_apply_company_names: [],
      },

      o6_status: {
        count: 0,
        company_names: [],
        complete_count: 0,
        complete_company_names: [],
        no_count: 0,
        no_company_names: [],
        not_apply_count: 0,
        not_apply_company_names: [],
      },
      o3_status: { count: 0, company_names: [], complete_count: 0, complete_company_names: [], no_count: 0, no_company_names: [], not_apply_count: 0, not_apply_company_names: [], },
      o4_status: { count: 0, company_names: [], complete_count: 0, complete_company_names: [], no_count: 0, no_company_names: [], not_apply_count: 0, not_apply_company_names: [], },
      o7_status: { count: 0, company_names: [], complete_count: 0, complete_company_names: [], no_count: 0, no_company_names: [], not_apply_count: 0, not_apply_company_names: [], },
      o8_status: { count: 0, company_names: [], complete_count: 0, complete_company_names: [], no_count: 0, no_company_names: [], not_apply_count: 0, not_apply_company_names: [], },
      o9_status: { count: 0, company_names: [], complete_count: 0, complete_company_names: [], no_count: 0, no_company_names: [], not_apply_count: 0, not_apply_company_names: [], },
      o10_status: { count: 0, company_names: [], complete_count: 0, complete_company_names: [], no_count: 0, no_company_names: [], not_apply_count: 0, not_apply_company_names: [], },
      o10_2_status: { count: 0, company_names: [], complete_count: 0, complete_company_names: [], no_count: 0, no_company_names: [], not_apply_count: 0, not_apply_company_names: [], },
      o11_status: { count: 0, company_names: [], complete_count: 0, complete_company_names: [], no_count: 0, no_company_names: [], not_apply_count: 0, not_apply_company_names: [], },
      o12_status: { count: 0, company_names: [], complete_count: 0, complete_company_names: [], no_count: 0, no_company_names: [], not_apply_count: 0, not_apply_company_names: [], },
      o13_status: { count: 0, company_names: [], complete_count: 0, complete_company_names: [], no_count: 0, no_company_names: [], not_apply_count: 0, not_apply_company_names: [], },
    });

    const handleScrollTo = (id, targetUrl) => {
      if (targetUrl && window.location.pathname !== targetUrl) {
        // 別ページなら localStorage に保存して navigate
        localStorage.setItem('scrollToId', id);
        navigate(targetUrl);
      } else {
        // 同ページなら即スクロール
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    };

    useEffect(() => {
      const scrollToId = localStorage.getItem('scrollToId');
      if (scrollToId) {
        // requestAnimationFrame で描画完了後にスクロール
        requestAnimationFrame(() => {
          const el = document.getElementById(scrollToId);
          if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
          localStorage.removeItem('scrollToId');
        });
      }
    }, []);

    const user = JSON.parse(localStorage.getItem("user"));

    const repId = user?.representative_id

    useEffect(() => {
      if (!repId) return; // userがnullのときはskip
      api.get('/api/submission-status-summary', {
        params: {
          representative_id: repId // 任意で送る
        }
      })
      .then(res => {
        setStatusSummary(res.data);
      })
      .catch(err => {
        console.error("提出状況集計の取得に失敗:", err);
      });
    }, [repId]);

    const [exhibitors, setExhibitors] = useState([]);
    const [filterRequired, setFilterRequired] = useState(true);
    const [filterOptional, setFilterOptional] = useState(true);
    const [filterContractor, setFilterContractor] = useState(true);
    const [pendingSearchName, setPendingSearchName] = useState('');
    const [pendingSearchBoothNumber, setPendingSearchBoothNumber] = useState('');
    const [pendingSearchStatus, setPendingSearchStatus] = useState('');
    const [pendingFilterRequired, setPendingFilterRequired] = useState(true);
    const [pendingFilterOptional, setPendingFilterOptional] = useState(true);
    const [pendingFilterContractor, setPendingFilterContractor] = useState(true);
    const [searchStatus, setSearchStatus] = useState('');
    const [searchBoothNumber, setSearchBoothNumber] = useState('');
    const itemsPerPage = 5;
    const [exhibitorPage, setExhibitorPage] = useState(1);
    const [showOnlyOwnFields, setShowOnlyOwnFields] = useState(true);
    const [searchName, setSearchName] = useState('');
    

    const [mypageModalOpen, setMypageModalOpen] = useState(false);
    const [mypageExhibitorId, setMypageExhibitorId] = useState(null);
    const [mypageData, setMypageData] = useState(null);
    const [pageInput, setPageInput] = useState(exhibitorPage);

    const handlePageChange = () => {
      let page = Number(pageInput);

      if (isNaN(page)) return;

      if (page < 1) page = 1;
      if (page > exhibitorTotalPages) page = exhibitorTotalPages;

      setExhibitorPage(page);
    };

    useEffect(() => {
    if (mypageModalOpen && mypageExhibitorId != null && exhibitors.length > 0) {
      const exhibitorId = mypageExhibitorId
      if (exhibitorId) {
        api.get(`/api/mypage/${exhibitorId}`)
          .then(res => setMypageData(res.data))
          .catch(err => console.error("マイページ取得失敗:", err));
      }
    }
  }, [mypageModalOpen, mypageExhibitorId, exhibitors]);

    useEffect(() => {
      api.get('/api/co-dashboard', {
        params: {
          status: searchStatus,
        }
      })
      .then(async res => {
        const rawExhibitors = res.data;

        // ✅ 小間番号ソート処理
        const parseBooth = (boothNumber) => {
          if (!boothNumber) return ['ZZZ', 9999];

          // 全角→半角変換＆トリム
          const normalized = boothNumber
            .replace(/[Ａ-Ｚａ-ｚ０-９－ー−]/g, s => {
              if (s === '－' || s === 'ー' || s === '−') return '-';
              return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
            })
            .trim()
            .toUpperCase();

          // A-1 や A1 形式をキャッチ
          const match = normalized.match(/^([A-Z]+)-?(\d{1,4})$/);
          if (match) {
            return [match[1], parseInt(match[2], 10)]; // 通常番号
          } else {
            // 数字のないものは後ろに並べるため「ZZZ」として扱う
            return ['ZZZ', 9999];
          }
        };

        const sortedExhibitors = [...rawExhibitors].sort((a, b) => {
          const [aLetter, aNum] = parseBooth(a.booth_number);
          const [bLetter, bNum] = parseBooth(b.booth_number);

          if (aLetter < bLetter) return -1;
          if (aLetter > bLetter) return 1;
          return aNum - bNum;
        });

        // ✅ ソート済みで保存
        setExhibitors(sortedExhibitors);
      })
      .catch(err => console.error('取得失敗:', err));
    }, []);

    const total = exhibitors?.length || 0;
    
    const representativeCategory = useMemo(() => {
      if (!user?.view_category) return null;
      return user.view_category;
    }, [user]);


    const getFilteredFields = () => {
      if (!representativeCategory) return [];

      return FIELD_CONFIGS.filter((field) =>
        showOnlyOwnFields
          ? representativeCategory.includes(field.category)
          : true
      );
    };

    const categoryToKeys = useMemo(() => ({
      3: ['o3_exhibitor_status', 'o3_corporate_status'],
      5: ['o5_exhibitor_status', 'o5_corporate_status'],
      6: ['o6_exhibitor_status', 'o6_corporate_status'],
      7: ['o7_exhibitor_status', 'o7_corporate_status'],
      8: ['o8_exhibitor_status', 'o8_corporate_status'],
      9: ['o9_exhibitor_status', 'o9_corporate_status'],
      10: ['o10_exhibitor_status', 'o10_corporate_status'],
      14: ['o10_2_exhibitor_status', 'o10_2_corporate_status'],
      12: ['o11_exhibitor_status', 'o12_corporate_status'],
    }));

    const filteredExhibitors = useMemo(() => {
    if (!representativeCategory) return [];

    return exhibitors.filter((exhibitor) => {
      const nameMatch = String(exhibitor.company_name ?? '').includes(searchName);
      const boothNumberMatch = String(exhibitor.booth_number ?? '').includes(searchBoothNumber);

      // 🔹 change_category に含まれる field だけを対象に currentStatus を作る
      const user = JSON.parse(localStorage.getItem("user"));
      const change_category = user.change_category
      const currentStatuses = getFilteredFields()
        .filter((field) => change_category?.includes(field.category))
        .map((field) => {
          const exhibitorStatus = exhibitor[`${field.key}_exhibitor_status`];
          const hostStatus = exhibitor[`${field.key}_host_status`];
          const corporateStatus = exhibitor[`${field.key}_corporate_status`];
          const candidates = [
            exhibitorStatus,
            hostStatus,
            corporateStatus,
          ].filter(Boolean);

          const STATUS_PRIORITY = [
            '再提出',
            '未提出',
            '未確認',
            '確認中',
            '1のみ確認済',
            '2のみ確認済',
            '確認済',
            '申請しない',
          ];

          let currentStatus = '未提出';

          if (
            exhibitorStatus === '再提出' &&
            hostStatus === '未確認' &&
            corporateStatus === '未確認'
          ) {
            currentStatus = '再提出';
          } else if (
            hostStatus === '未確認' &&
            corporateStatus === '未確認' &&
            exhibitorStatus !== '再提出'
          ) {
            currentStatus = '未確認';
          } else {
            for (const status of STATUS_PRIORITY) {
              if (candidates?.includes(status)) {
                currentStatus = status;
                break;
              }
            }
          }

          return currentStatus;
        });

      // searchStatus が空なら全部通す
      if (searchStatus.length === 0) return nameMatch && boothNumberMatch;

      // searchStatus に含まれる currentStatus が一つでもあれば通す
      const statusMatch = currentStatuses.some((status) => searchStatus?.includes(status));

      return nameMatch && boothNumberMatch && statusMatch;
    });
  }, [searchName, searchBoothNumber, searchStatus, exhibitors, representativeCategory]);

    const paginatedExhibitors = filteredExhibitors.slice(
      (exhibitorPage - 1) * itemsPerPage,
      exhibitorPage * itemsPerPage
    );
    
    const exhibitorTotalPages = Math.ceil(filteredExhibitors.length / itemsPerPage);
    const applyFilters = () => {
      setSearchName(pendingSearchName);
      setSearchBoothNumber(pendingSearchBoothNumber);
      setSearchStatus(pendingSearchStatus); // ← 配列のまま渡す
      setFilterRequired(pendingFilterRequired);
      setFilterOptional(pendingFilterOptional);
      setFilterContractor(pendingFilterContractor);
    };

    const clearFilters = () => {
      setPendingSearchName('');
      setPendingSearchBoothNumber('');
      setPendingSearchStatus([]); // ← 配列を空に戻す
      setPendingFilterRequired(true);
      setPendingFilterOptional(true);
      setPendingFilterContractor(true);
    };

    const isFieldDisabled = (category) => {
      if (!representativeCategory) return true;
      return !representativeCategory.includes(category);
    };

    const conRepId = user?.representative_id

    const renderForm = (formKey, exhibitorId) => {
      const key = `${formKey}-${exhibitorId}`;
      switch (formKey) {
        case 'r1':
          return (
            <FormRequire
              key={key}
              exhibitorId={exhibitorId}
              isCorpModal={true}
              changeModalOpen={changeModalOpen}
              selectedFormKey={formKey}
              selectedExhibitorId={exhibitorId}
              setFormModalOpen={setFormModalOpen}
              setExhibitors={setExhibitors}
              exhibitors={exhibitors}
            />
          );
        case 'o3':
          return (
            <Comp3Sub
              key={key}
              exhibitorId={exhibitorId}
              isCorpModal={true}
              changeModalOpen={changeModalOpen}
              selectedFormKey={formKey}
              selectedExhibitorId={exhibitorId}
              setFormModalOpen={setFormModalOpen}
              setExhibitors={setExhibitors}
              exhibitors={exhibitors}
            />
          );
        case 'o4':
          return (
            <Comp4Sub
              key={key}
              exhibitorId={exhibitorId}
              isCorpModal={true}
              changeModalOpen={changeModalOpen}
              selectedFormKey={formKey}
              selectedExhibitorId={exhibitorId}
              setFormModalOpen={setFormModalOpen}
              setExhibitors={setExhibitors}
              exhibitors={exhibitors}
            />
          );
          case 'o5':
          return (
            <Comp5Sub
              key={key}
              exhibitorId={exhibitorId}
              isCorpModal={true}
              changeModalOpen={changeModalOpen}
              selectedFormKey={formKey}
              selectedExhibitorId={exhibitorId}
              setFormModalOpen={setFormModalOpen}
              setExhibitors={setExhibitors}
              exhibitors={exhibitors}
            />
          );
          case 'o6':
          return (
            <Comp6Sub
              key={key}
              exhibitorId={exhibitorId}
              isCorpModal={true}
              changeModalOpen={changeModalOpen}
              selectedFormKey={formKey}
              selectedExhibitorId={exhibitorId}
              setFormModalOpen={setFormModalOpen}
              setExhibitors={setExhibitors}
              exhibitors={exhibitors}
            />
          );
          case 'o7':
          return (
            <Comp7Sub
              key={key}
              exhibitorId={exhibitorId}
              isCorpModal={true}
              changeModalOpen={changeModalOpen}
              selectedFormKey={formKey}
              selectedExhibitorId={exhibitorId}
              setFormModalOpen={setFormModalOpen}
              setExhibitors={setExhibitors}
              exhibitors={exhibitors}
            />
          );
          case 'o8':
          return (
            <Comp8Sub
              key={key}
              exhibitorId={exhibitorId}
              isCorpModal={true}
              changeModalOpen={changeModalOpen}
              selectedFormKey={formKey}
              selectedExhibitorId={exhibitorId}
              setFormModalOpen={setFormModalOpen}
              setExhibitors={setExhibitors}
              exhibitors={exhibitors}
              conRepId={conRepId}
            />
          );
          case 'o9':
          return (
            <Comp9Sub
              key={key}
              exhibitorId={exhibitorId}
              isCorpModal={true}
              changeModalOpen={changeModalOpen}
              selectedFormKey={formKey}
              selectedExhibitorId={exhibitorId}
              setFormModalOpen={setFormModalOpen}
              setExhibitors={setExhibitors}
              exhibitors={exhibitors}
            />
          );
          case 'o10':
          return (
            <Comp10Sub
              key={key}
              exhibitorId={exhibitorId}
              isCorpModal={true}
              changeModalOpen={changeModalOpen}
              selectedFormKey={formKey}
              selectedExhibitorId={exhibitorId}
              setFormModalOpen={setFormModalOpen}
              setExhibitors={setExhibitors}
              exhibitors={exhibitors}
            />
          );
          case 'o10_2':
          return (
            <Comp10_2Sub
              key={key}
              exhibitorId={exhibitorId}
              isCorpModal={true}
              changeModalOpen={changeModalOpen}
              selectedFormKey={formKey}
              selectedExhibitorId={exhibitorId}
              setFormModalOpen={setFormModalOpen}
              setExhibitors={setExhibitors}
              exhibitors={exhibitors}
            />
          );
          case 'o12':
          return (
            <Comp12Sub
              key={key}
              exhibitorId={exhibitorId}
              isCorpModal={true}
              changeModalOpen={changeModalOpen}
              selectedFormKey={formKey}
              selectedExhibitorId={exhibitorId}
              setFormModalOpen={setFormModalOpen}
              setExhibitors={setExhibitors}
              exhibitors={exhibitors}
            />
          );
          case 'o13':
          return (
            <Comp13Sub
              key={key}
              exhibitorId={exhibitorId}
              isCorpModal={true}
              changeModalOpen={changeModalOpen}
              selectedFormKey={formKey}
              selectedExhibitorId={exhibitorId}
              setFormModalOpen={setFormModalOpen}
              setExhibitors={setExhibitors}
              exhibitors={exhibitors}
            />
          );
        default:
          return <p>フォームが見つかりませんでした</p>;
      }
    };

    useEffect(() => {
      const fetchNotices = async () => {
        try {
          const res = await api.get(`/api/notices?skip=${(page - 1) * noticesPerPage}&limit=${noticesPerPage}`);
          setNotices(res.data.items);
          setTotal(res.data.totalN);
        } catch (err) {
          console.error('お知らせ一覧の取得に失敗:', err);
        }
      };
      fetchNotices();
    }, [page]);
    const handleLogout = () => {
      localStorage.removeItem('user');
      sessionStorage.clear(); // ← これ追加！
      navigate('/');
    };

  const unifiedRows = useMemo(() => {
        const merged = {};
        Object.entries(fetchedData).forEach(([category, list]) => {
          list.forEach((item) => {
            const eid = item.exhibitor_id;
            if (!merged[eid]) {
              merged[eid] = {
                exhibitor_id: eid,
                company_name: item.company_name,
                email: item.email,
                exhibitor_status: item.exhibitor_status || "",
                corporate_status: item.corporate_status || "",
                categories: {},
              };
            }
          });
        });

        return Object.values(merged).filter((item) => {
          const matchCompany = item.company_name.toLowerCase().includes(companyNameFilter.toLowerCase());
          const matchExhibitorStatus = exhibitorStatuses.length === 0 || exhibitorStatuses.includes(item.exhibitor_status);
          const matchCorpStatus = corporateStatuses.length === 0 || corporateStatuses.includes(item.corporate_status);
          return matchCompany && matchExhibitorStatus && matchCorpStatus;
        });
      }, [fetchedData, exhibitorStatuses, corporateStatuses, companyNameFilter]);
      
  let topPath = '/';
  if (location.pathname.includes('contractor-mypage')) {
    topPath = `/contractor-mypage/${representativeId}`;
  } else if (location.pathname.includes('mypage')) {
    topPath = `/mypage/${representativeId}`;
  }
  
  const waitForIdleAndStableDOM = (targetElement, timeout = 3000) =>
    new Promise((resolve) => {
      let stableCount = 0;
      let lastHeight = targetElement.offsetHeight;

      const checkStable = () => {
        const nowHeight = targetElement.offsetHeight;
        if (nowHeight === lastHeight) {
          stableCount++;
          if (stableCount >= 3) {
            return resolve();
          }
        } else {
          stableCount = 0;
          lastHeight = nowHeight;
        }
        setTimeout(checkStable, 150);
      };

      if ('requestIdleCallback' in window) {
        requestIdleCallback(() => {
          setTimeout(checkStable, 150);
        }, { timeout });
      } else {
        setTimeout(checkStable, 150);
      }
    });
  
  const handlePDFDownload = async (representativeId) => {
    const fieldMap = Object.fromEntries(FIELD_CONFIGS.map(f => [f.key, f]));
    const selectedPairs = checkedPdfIds.map((id) => {
      const [exhibitor_id_raw, ...keyParts] = id.split("_");
      return { exhibitor_id: Number(exhibitor_id_raw), key: keyParts.join("_") };
    });

    // --- 企業情報を取得 ---
    const fetchCorporateInfo = async (representativeId) => {
      try {
        let repId = parseInt(representativeId, 10);
        const res = await api.get(`/api/corporate/${repId}`);

        if (res.status !== 200) {
          throw new Error("データ取得に失敗しました");
        }

        return res.data;
      } catch (err) {
        console.error("API呼び出し失敗:", err);
        throw err;
      }
    };

    const corporateInfo = await fetchCorporateInfo(representativeId);
    const corporateDataMap = corporateInfo.data;


    // --- PDF生成対象を作成 ---
    const targets = selectedPairs.map(({ exhibitor_id, key }) => {
      const fieldConfig = fieldMap[key];
      if (!fieldConfig) return null;

      const category = fieldConfig.category;
      const forms = corporateDataMap[category];
      if (!forms) return null;

      const matchedForm = forms.find(f => f.exhibitor_id === exhibitor_id);
      if (!matchedForm) return null;

      return {
        exhibitor_id,
        company_name: matchedForm.company_name,
        selectedCategories: [key],
        categories: {
          [key]: matchedForm,
        }
      };
    }).filter(Boolean);

    if (!targets.length) return alert("出力対象が選択されていません");


    // --- user_id を取得して User0 を付与 ---
    const fetchUserId = async (exhibitor_id) => {
      try {
        const res = await api.get(`/api/users/${exhibitor_id}`);
        if (res.status === 200) {
          return res.data.user_id;
        }
      } catch (err) {
        console.error("user_id取得失敗:", err);
      }
      return null;
    };

    const targetsWithUser0 = await Promise.all(
      targets.map(async (row) => {
        const user_id = await fetchUserId(row.exhibitor_id);
        return {
          ...row,
          User0: user_id === 0, // user_id=0ならtrue
        };
      })
    );

    const pdfBlobs = [];

    for (const row of targetsWithUser0) {
      for (const fieldKey of row.selectedCategories) {
        const form = row.categories[fieldKey];
        const fieldConfig = fieldMap[fieldKey];


        const reqData = {
          company_name: form.company_name,
          booth_number: form.booth_number,
          department: form.department,
          address: form.address,
          phone_number: form.phone_number,
          email: form.email,
          user_name: form.user_name,
          r1: form.r1?.[0] || {},
          r2: form.r2?.[0] || {},
        };

        const elecData = {
          company_name: form.company_name,
          booth_number: form.booth_number,
          department: form.department,
          address: form.address,
          phone_number: form.phone_number,
          email: form.email,
          user_name: form.user_name,
          o5: form.o5?.[0] || {},
          o6: form.o6?.[0] || {},
        };

        if (!fieldConfig) continue;

        const container = document.createElement("div");
        document.body.appendChild(container);
        const root = createRoot(container);

        const renderComponent = (formKey) => {
          switch (formKey) {
            case 'r1':
              const hasPackage = !!(
                reqData?.r1?.package_company_name ||
                reqData?.r1?.package_company_tel ||
                reqData?.r1?.package_phone_number ||
                reqData?.r1?.package_company_zip ||
                reqData?.r1?.package_company_address ||
                reqData?.r1?.package_company_fax ||
                reqData?.r1?.package_name
              );

              const hasElec = !!(
                reqData?.r1?.elec_company_name ||
                reqData?.r1?.elec_company_tel ||
                reqData?.r1?.elec_phone_number ||
                reqData?.r1?.elec_company_zip ||
                reqData?.r1?.elec_company_address ||
                reqData?.r1?.elec_company_fax ||
                reqData?.r1?.elec_name
              );

              const hasInfla = !!(
                reqData?.r1?.infla_company_name ||
                reqData?.r1?.infla_company_tel ||
                reqData?.r1?.infla_phone_number ||
                reqData?.r1?.infla_company_zip ||
                reqData?.r1?.infla_company_address ||
                reqData?.r1?.infla_company_fax ||
                reqData?.r1?.infla_name
              );

              const hasCargo = !!(
                reqData?.r1?.cargo_company_name ||
                reqData?.r1?.cargo_company_tel ||
                reqData?.r1?.cargo_phone_number ||
                reqData?.r1?.cargo_company_zip ||
                reqData?.r1?.cargo_company_address ||
                reqData?.r1?.cargo_company_fax ||
                reqData?.r1?.cargo_name
              );

              // まとめる
              const checkedR1 = {
                has_package_company: hasPackage,
                has_elec_company: hasElec,
                has_infla_company: hasInfla,
                has_cargo_company: hasCargo,
              };
              return <FormRequirePDF reqData={{ 
                ...reqData, 
                r1: { ...reqData.r1, ...checkedR1 } 
              }} User0={row.User0} />;
            case 'o3':
              return <Comp3PDF formData={form} />;
            case 'o4':
              return <Comp4PDF formData={form} />;
            case 'o5':
              const hasV100 =
              form?.o5?.[0]?.details_100?.some(d =>
                d.device_100_name || d.quantity_100 || d.number_100 || d.total_100 || d.ex_100
              ) ||
              (form?.o5?.[0]?.quantity_100v !== null &&
              form?.o5?.[0]?.quantity_100v !== undefined &&
              Number(form?.o5?.[0]?.quantity_100v) > 0);

            const hasV200 =
              form?.o5?.[0]?.details_200?.some(d =>
                d.device_200_name || d.quantity_200 || d.number_200 || d.total_200 || d.ex_200
              ) ||
              (form?.o5?.[0]?.quantity_200v !== null &&
              form?.o5?.[0]?.quantity_200v !== undefined &&
              Number(form?.o5?.[0]?.quantity_200v) > 0);

            const localChecked = {
              v100: !!hasV100,
              v200: !!hasV200
            };

            return <FormElectricityPDF elecData={form} checked={localChecked} elecItems={elecItems} />;
            case 'o7':
              const hasWater = form.water;
              const hasAir = form.air;
              const hasGas = form.gas;

              const gasObj = {
                water: !!hasWater,
                air: !!hasAir,
                gas: !!hasGas,
              };

              setGasChecked(gasObj);
              return <Comp7PDF formData={form} checked={gasObj} />;
            case 'o8':
              let plans = [];
              if (form.plan && Array.isArray(form.plan)) {
                plans = form.plan.map(p => ({
                  value: p.value,
                  label: p.label,
                  quantity: p.quantity || 1,
                }));
                setSelectedPlans(plans); // ← stateに残したいならここはそのまま
              }

              const hasPack = plans.length > 0 ||
                form.plate_select ||
                form.plate_info ||
                form.carpet_color ||
                form.outlet ||
                form.add_select ||
                (form.add_detail && form.add_detail !== "A:0,B:0,C:0,D:0");

              const hasStorage = (form.normal_box && form.normal_box !== 0) ||
                (form.other_box && form.other_box !== 0);

              const hasIphone = form.smartphone !== null || (form.add_smartphone && form.add_smartphone > 0);

              const hasAdd = (form.add_smartphone && form.add_smartphone > 0);

              const checkedObj = {
                pack: !!hasPack,
                storage: !!hasStorage,
                iphone: !!hasIphone,
                add: !!hasAdd,
              };

              setChecked(checkedObj);

              return <Comp8PDF formData={form} checked={checkedObj} selectedPlans={plans} />;
            case 'o9':
              return <Comp9PDF formData={form} rentalItems={rentalItems} />;
            case 'o10':
              return <Comp10PDF formData={form} items={pcItems} />;
            case 'o10_2':
              return <Comp10_2PDF formData={form} />;
            case 'o12':
              const hasGarbage = form.garbage_plan?.length > 0;
              const hasOil = form.lubricating_oil || form.waste_oil;
              const hasClean = form.cleanup;

              const cleanObj = {
                garbage: !!hasGarbage,
                oil: !!hasOil,
                clean: !!hasClean,
              };

              setCleanChecked(cleanObj);
              return <Comp12PDF formData={form} checked={cleanObj} />;
            case 'o13':
              return <Comp13PDF formData={form} />;
            default:
              return <p>フォームが見つかりませんでした</p>;
          }
        };

        root.render(
          <div
            style={{
              width: "210mm",
              minHeight: "297mm",
              padding: "10mm",
              background: "#fff",
              transform: "scale(1.5)",
              transformOrigin: "top left",
              overflow: "visible",
            }}
          >
            {renderComponent(fieldKey)}
          </div>
        );

        const baseUrl =
        window.location.hostname === 'localhost'
          ? 'http://127.0.0.1:8000'          // ローカル開発用
          : 'https://messenagoya.ex-link.net'; // 本番 HTTPS

        await waitForIdleAndStableDOM(container);
        container.style.height = `${container.scrollHeight}px`;

        if (fieldKey === "o13") {
          // ZIP先にダウンロード
          const res = await fetch(`${baseUrl}/api/o13/download/${row.exhibitor_id}`, { cache: "no-store" });
          if (!res.ok) throw new Error("zip ダウンロード失敗");
          const blob = await res.blob();
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = `${row.company_name}_ブース平面図.zip`;
          a.click();
          window.URL.revokeObjectURL(url);

          // DOMが安定するまで待ってからPDF
          await waitForIdleAndStableDOM(container);

          const canvas = await html2canvas(container, { scale:2, useCORS:true, allowTaint:true, backgroundColor:"#fff" });
          const imgData = canvas.toDataURL("image/png");
          const pdf = new jsPDF("p","mm","a4");
          pdf.addImage(imgData,"PNG",0,0,210,(canvas.height*210)/canvas.width);
          pdf.save(`${row.company_name}_o13.pdf`);
        } else {
          // o13以外は従来通りPDFレンダリング
          const canvas = await html2canvas(container, {
            scale: 2,
            useCORS: true,
            allowTaint: true,
            backgroundColor: "#ffffff",
          });

          const imgData = canvas.toDataURL("image/png");
          const imgWidth = 210;
          const pageHeight = 297;
          const imgHeight = (canvas.height * imgWidth) / canvas.width;
          const pdf = new jsPDF("p", "mm", "a4");
          let heightLeft = imgHeight;
          let position = 0;

          pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;

          while (heightLeft > 0) {
            position -= pageHeight;
            pdf.addPage();
            pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;
          }

          const company = row.company_name || "output";
          const safeCompany = company.replace(/[\\/:*?"<>|]/g, '_');
          const label = fieldConfig.label || fieldKey;
          const pdfBlob = pdf.output("blob");
          pdfBlobs.push({ blob: pdfBlob, filename: `${safeCompany}_${label}.pdf` });
        }

        root.unmount();
        document.body.removeChild(container);
      }
    }
      if (pdfBlobs.length > 1) {
      const zip = new JSZip();
      pdfBlobs.forEach(p => zip.file(p.filename, p.blob));
      const zipBlob = await zip.generateAsync({ type: "blob" });
      const url = window.URL.createObjectURL(zipBlob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "出力PDFまとめ.zip";
      a.click();
      window.URL.revokeObjectURL(url);
    } else if (pdfBlobs.length === 1) {
      const a = document.createElement("a");
      a.href = window.URL.createObjectURL(pdfBlobs[0].blob);
      a.download = pdfBlobs[0].filename;
      a.click();
    }
  };


  const categoryNames = {
      3: "運送・会場内荷役作業申込",
      5: "電気・電力使用申込",
      6: "電気備品レンタル申込",
      7: "給排水・エア・ガス申込",
      8: "パッケージ装飾・出展者専用倉庫・名刺交換用iPhone申込",
      9: "装飾備品レンタル申込",
      10: "PC・ソフトレンタル申込",
      14: "インターネット接続申込",
      12: "ゴミ・廃材・廃油処理・小間内清掃申込",
    };

  const handleStatusClick = (formKey, exhibitorId, currentStatus, category) => {
    if (currentStatus === '申請しない') return;

    if (Array.isArray(user?.change_category)) {
      if (user.change_category.includes(category)) {
        setChangeModalOpen(true);
      } else {
        setChangeModalOpen(false);
      }
    } else {
      if (String(user?.change_category) === String(category)) {
        setChangeModalOpen(true);
      } else {
        setChangeModalOpen(false);
      }
    }

    setSelectedFormKey(formKey);
    setSelectedExhibitorId(exhibitorId);
    setFormModalOpen(true);
  };

  const getStatusImage = (status, isDisabled = false) => {
    // 優先順位マップ
    const priority = [
      '未確認',
      '1のみ確認済',
      '2のみ確認済',
      '確認済',
      '申請しない',
      '確認中',
      '未提出', // null もここに含める
      '再提出',
    ];

    // 提出済みは表示しない
    if (status === '提出済み') return null;

    // null 対応
    const normalizedStatus = status ?? '未提出';

    // 優先度を反映
    const baseName = (() => {
      switch (normalizedStatus) {
        case '確認済': return '確認済み';
        case '確認中': return '確認中';
        case '未確認': return '未確認';
        case '1のみ確認済': return '1のみ確認済';
        case '2のみ確認済': return '2のみ確認済';
        case '未提出': return '未提出a';
        case '再提出': return '再提出';
        case '申請しない': return '申請しない';
        default: return '未提出a';
      }
    })();

    return isDisabled
      ? `/status_${baseName}_disabled.png`
      : `/status_${baseName}.png`;
  };


    const fieldStatusCounts = useMemo(() => {
      if (!exhibitors || !user?.view_category || !user?.change_category || !representativeId) return {};

      const counts = {};

      FIELD_CONFIGS.forEach(({ key, label, category }) => {
        // change_category 側を優先
        if (user.change_category.includes(category)) {
          // 会社名は statusSummary から取得
          let summaryKey;
          if (key === 'r1') summaryKey = 'required_submission';
          else if (key === 'o5') summaryKey = 'o5_status';
          else summaryKey = `${key}_status`;

          const summaryData = statusSummary[summaryKey] || {};

          counts[key] = {
            label,
            確認済: summaryData.complete_count ?? 0,
            未確認: summaryData.no_count ?? 0,
            申請しない: summaryData.not_apply_count ?? 0,
            確認済CompanyNames: summaryData.complete_company_names ?? [],
            申請しないCompanyNames: summaryData.not_apply_company_names ?? [],
            未確認CompanyNames: summaryData.no_company_names ?? [],
          };

          return;
        }

        // view_category 側
        if (user.view_category.includes(category)) {
          let summaryKey;
          if (key === 'r1') summaryKey = 'required_submission';
          else if (key === 'o5') summaryKey = 'o5_status';
          else summaryKey = `${key}_status`;

          const summaryData = statusSummary[summaryKey];
          if (!summaryData) return;

          counts[key] = {
            label,
            提出数: summaryData.count,
            companyNames: summaryData.company_names || [],
          };
          return;
        }
      });

      return counts;
    }, [exhibitors, user, representativeId, statusSummary]);

    const [openPopup, setOpenPopup] = useState(false);
    const [popupTitle, setPopupTitle] = useState('');
    const [popupCompanyNames, setPopupCompanyNames] = useState([]);
  
    const handleShowCompanyNames = (key, names) => {
      const field = FIELD_CONFIGS.find(f => f.key === key);
      const label = field ? field.label : key; // 見つからなかったら key を fallback
      setPopupTitle(label);
      setPopupCompanyNames(names);
      setOpenPopup(true);
    };

    const handleEXCELDownload = async () => {
    try {
      const res = await api.post(
        "/api/export-excel",
        { view_category: user.view_category },
        { responseType: "blob" } // Excelはバイナリ
      );


      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "申請書一覧.xlsx";
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Excelダウンロード失敗:", err);
    }
  };

      const fixedColsWidth = 120 + 90; // 会社名 + 小間番号の列幅
      const dynamicColsWidth = getFilteredFields().length * 110;
      const totalWidth = fixedColsWidth + dynamicColsWidth;

      useConfirmBackLogout(navigate);

      const fetchLatestHistory = async (exhibitorId) => {
        const res = await api.get(`/api/latest-history/${exhibitorId}`);

        const map = {};
        res.data.forEach((item) => {
          map[item.submission_number] = item.changed_at;
        });

        setLatestHistoryMap((prev) => ({
          ...prev,
          [exhibitorId]: map,
        }));
      };
      useEffect(() => {
        if (!paginatedExhibitors?.length) return;
    
        const ids = paginatedExhibitors.map((e) => e.exhibitor_id);
    
        const fetchAll = async () => {
          await Promise.all(
            ids.map((id) => fetchLatestHistory(id))
          );
        };
    
        fetchAll();
      }, [paginatedExhibitors.map(e => e.exhibitor_id).join(",")]);

        return(
        <div>
          <Header
            title="メッセナゴヤ 協力会社マイページ"
            companyName={mypageData?.company_name}
          />
          <Container sx={{ display: 'flex' }}>
            <Container sx={{ width: '20%', mt: 4 }}>
              <Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                  <Box
                  className="menu-item"
                  onClick={() => {
                    const user = JSON.parse(localStorage.getItem('user'));
                    const mypage = user?.mypage_url;
                    navigate(mypage);
                    }}
                  >
                    TOP
                  </Box>
                  <Box
                  className="menu-item"
                  onClick={() => {
                    const user = JSON.parse(localStorage.getItem('user'));
                    const repId = user?.representative_id;
                    navigate(`/corporate-mypage-info/${repId}`);
                    }}
                  >
                    協力会社情報編集
                  </Box>
                  <Box 
                    className="menu-item"
                    onClick={() => {
                      navigate('/mail-form/');
                    }}
                  >
                    お問い合わせ
                  </Box>
                  <Box 
                    className="menu-item"
                    onClick={() => {
                      const user = JSON.parse(localStorage.getItem('user') || '{}');
                      const mypage = user?.mypage_url;

                      handleScrollTo('news', mypage);
                    }}
                  >
                    お知らせ
                  </Box>
                </Box>
              </Box>
            </Container>
            <Container sx={{ width: '80%'}}>
              <Box sx={{ mt: 4 }} className='form-status-box'>
                <Box className='form-status-title' sx={{ display: 'flex' , alignItems: 'center' , justifyContent: 'space-between' }}>
                  <Typography variant="h6">　申請書提出状況</Typography>
                  <Typography variant="h6">申込件数:{total} 社</Typography>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: 4, mt: 2, pb: 2 }}>
                  {Object.entries(fieldStatusCounts).map(([key, data]) => (
                    <Box key={key} sx={{ textAlign: 'center', border: '1px solid #ccc', borderRadius: 2, px: 2, py: 1, minWidth: 120 }}>
                      <Typography variant="subtitle2">{data.label}</Typography>
                      <Box sx={{ display: "flex", gap: 4, justifyContent: "center" }}>
                        {data.提出数 !== undefined ? (
                          <Typography
                           variant="body2"
                           sx={{ color: '#666' }}
                           onClick={() => handleShowCompanyNames(
                            key,
                            data.companyNames
                           )}
                          >
                            提出数<br /><span className="big-number">{data.提出数}</span>社
                          </Typography>
                        ) : (
                          <>
                            <Typography
                             variant="body2"
                             sx={{ color: '#666' }}
                             onClick={() => handleShowCompanyNames(
                              key,
                              data.確認済CompanyNames
                             )}
                            >
                              確認済<br /><span className="big-number">{data.確認済}</span>社
                            </Typography>
                            <Typography
                             variant="body2"
                             sx={{ color: '#666' }}
                             onClick={() => handleShowCompanyNames(
                              key,
                              data.申請しないCompanyNames
                             )}
                            >
                              申請しない<br /><span className="big-number">{data.申請しない}</span>社
                            </Typography>
                            <Typography
                              variant="body2"
                              sx={{ color: '#666' }}
                              onClick={() => handleShowCompanyNames(
                                key,
                                data.未確認CompanyNames
                              )}
                            >
                              未確認<br /><span className="big-number">{data.未確認}</span>社
                            </Typography>
                          </>
                        )}
                      </Box>
                      <Dialog open={openPopup} onClose={() => setOpenPopup(false)}>
                        <DialogTitle>{popupTitle}</DialogTitle>
                        <DialogContent>
                          <List>
                            {popupCompanyNames.length > 0 ? popupCompanyNames.map((name, idx) =>
                              <ListItem key={idx}><ListItemText primary={name} /></ListItem>
                            ) : <ListItem><ListItemText primary="該当なし" /></ListItem>}
                          </List>
                        </DialogContent>
                      </Dialog>
                    </Box>
                  ))}
                </Box>
              </Box>
              <Box sx={{ mt: 6 }} className="notice-box">
                <Box className='notice-title'>
                  <Typography variant="h6" gutterBottom className='title'><i className="bi bi-list"></i>検索条件</Typography>
                </Box>
                <Box>
                  <Box sx={{ display: 'flex' , alignItems: "center", px: 5 , py: 3 }}>
                    <Typography variant="h6" sx={{ mr:3 }}>会社名　　</Typography>
                    <TextField
                      variant="outlined"
                      value={pendingSearchName}
                      onChange={(e) => setPendingSearchName(e.target.value)}
                    />
                  </Box>
                  <Box sx={{ display: 'flex' , alignItems: "center", px: 5 , py: 3 }}>
                    <Typography variant="h6" sx={{ mr:3 }}>小間番号</Typography>
                    <TextField
                      variant="outlined"
                      value={pendingSearchBoothNumber}
                      onChange={(e) => setPendingSearchBoothNumber(e.target.value)}
                    />
                  </Box>
                </Box>
                {/* フィルターUI */}
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mb: 3, mt: 2 }}>
                  
                  <Typography sx={{ mx: 5 }} className='button-poi'>申請書</Typography>

                  {/* 提出・確認ステータス絞り込み */}
                  <FormControl component="fieldset" sx={{ display: 'flex', flexDirection: 'column', px: 5 }}>
                    <FormGroup row>
                      {[
                        { value: '未提出', label: '未提出' },
                        { value: '未確認', label: '未確認' },
                        { value: '再提出', label: '再提出' },
                        { value: '申請しない', label: '申請しない' },
                        { value: '確認済', label: '完了' }, // 表示名は「完了」
                      ].map((item) => (
                        <FormControlLabel
                          key={item.value}
                          control={
                            <Checkbox
                              checked={pendingSearchStatus.includes(item.value)}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setPendingSearchStatus([...pendingSearchStatus, item.value]);
                                } else {
                                  setPendingSearchStatus(
                                    pendingSearchStatus.filter((status) => status !== item.value)
                                  );
                                }
                              }}
                            />
                          }
                          label={item.label}
                        />
                      ))}
                    </FormGroup>
                  </FormControl>

                  {/* 必須・任意のチェックボックス */}
                  {/* <FormGroup row sx={{ px:5 }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={pendingFilterRequired}
                          onChange={(e) => setPendingFilterRequired(e.target.checked)}
                        />
                      }
                      label="必須"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={pendingFilterOptional}
                          onChange={(e) => setPendingFilterOptional(e.target.checked)}
                        />
                      }
                      label="任意"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={pendingFilterContractor}
                          onChange={(e) => setPendingFilterContractor(e.target.checked)}
                        />
                      }
                      label="協力会社"
                    />
                  </FormGroup> */}
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', px: 5, mt: 2, gap: 2 }}>
                    <Button variant="outlined" color="secondary" onClick={clearFilters}>
                      <i className="bi bi-eraser"></i>絞込削除
                    </Button>
                    <Button variant="contained" color="primary" onClick={applyFilters} sx={{ px:4 }}>
                      <i className="bi bi-search"></i>検索
                    </Button>
                  </Box>
                </Box>
              </Box>
              {/* 共通部分 */}
              <Box className="notice-box" sx={{ px:2, py:3,  }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Typography variant='h5' className='title' sx={{ mb: 3, px: 4 }}>申請書一覧</Typography>
                  <Button
                    variant={showOnlyOwnFields ? 'contained' : 'outlined'}
                    color="primary"
                    onClick={() => setShowOnlyOwnFields(prev => !prev)}
                    sx={{ mb: 3 }}
                  >
                    {showOnlyOwnFields ? (
                      <><i className="bi bi-globe"></i> 全申請書</>
                    ) : (
                      <><i className="bi bi-person-check"></i> 担当のみ</>
                    )}
                  </Button>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 2 }}>
                    <Button
                      variant="contained"
                      sx={{ mb: 3 }}
                      onClick={() => {
                        const changeCategoryIds = filteredExhibitors.flatMap(exhibitor =>
                          getFilteredFields() // フィルター済みのフィールド
                            .filter(f => user.change_category.includes(f.category))
                            .map(f => `${exhibitor.exhibitor_id}_${f.key}`)
                        );

                        const allChecked = changeCategoryIds.every(id => checkedPdfIds.includes(id));

                        setCheckedPdfIds(prev => {
                          if (allChecked) {
                            return prev.filter(id => !changeCategoryIds.includes(id)); // 一括解除
                          } else {
                            return [...prev, ...changeCategoryIds.filter(id => !prev.includes(id))]; // 一括チェック
                          }
                        });
                      }}
                    >
                      担当書類 一括選択
                    </Button>
                    <Button variant="outlined" color="secondary"  onClick={() => handlePDFDownload(representativeId)} disabled={checkedPdfIds.length === 0} sx={{ mb: 3, px: 2 }}>PDFダウンロード</Button>
                    <Button onClick={handleEXCELDownload} variant="outlined" color="secondary" sx={{mb: 3}}>Excelダウンロード</Button>
                  </Box>
                </Box>
                <Box sx={{ overflowX: 'auto', width: '100%' }}>
                  {/* 見出しラベル */}
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 0, backgroundColor: '#0071BC', color: '#FFF', textAlign: 'center' , width: `${totalWidth}px`, overflowX: 'hidden' }}>
                    <Typography sx={{ padding: '10px 0' ,width: 120, fontWeight: 'bold', borderRight: '1px solid #fff' }}>会社名</Typography>
                    <Typography sx={{ padding: '10px 0' ,width: 90, fontWeight: 'bold', borderRight: '1px solid #fff' }}>小間番号</Typography>
                    {getFilteredFields().map((field) => {
                      const { label } = field;

                      const handleColumnSelect = (key) => {
                        const columnIds = exhibitors.map(
                          (exhibitor) => `${exhibitor.exhibitor_id}_${key}`
                        );

                        const allChecked = columnIds.every((id) =>
                          checkedPdfIds.includes(id)
                        );

                        setCheckedPdfIds((prev) => {
                          if (allChecked) {
                            // 全解除
                            return prev.filter((id) => !columnIds.includes(id));
                          } else {
                            // 未チェック分を追加
                            return [...prev, ...columnIds.filter((id) => !prev.includes(id))];
                          }
                        });
                      };

                      return (
                        <Box
                          key={field.key}
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            borderRight: "1px solid #fff",
                            width: 110,
                            padding: "10px 0",
                          }}
                        >
                          {/* ラベル */}
                          <Typography sx={{ fontWeight: "bold", height: 50 }}>
                            {label}
                          </Typography>

                          {/* 一括チェックボタン */}
                          <Button
                            variant="outlined"
                            size="small"
                            color="white"
                            sx={{ mt: 1 }}
                            onClick={() => handleColumnSelect(field.key)}
                          >
                            一括
                          </Button>
                        </Box>
                      );
                    })}
                  </Box>
                  <Box>
                    <>
                      {paginatedExhibitors.map((exhibitor, index) => {
                        const isEven = index % 2 === 0;

                        return (
                          <Box
                            key={exhibitor.exhibitor_id}
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              mb: 0,
                              textAlign: 'center',
                              backgroundColor: isEven ? '#f5f5f5' : '#ffffff',
                              border: '1px solid #ccc',
                              width: `${totalWidth}px`,
                              overflowX: 'hidden'
                            }}
                          >
                            {/* 出展者の情報 */}
                            <Typography
                              sx={{
                                width: 120,
                                borderRight: '1px solid #ccc',
                                py: 1
                              }}
                              onClick={() => {
                                setMypageExhibitorId(exhibitor.exhibitor_id);
                                setMypageModalOpen(true);
                              }}
                            >
                              {exhibitor.company_name}
                            </Typography>
                            <Typography sx={{ width: 90, borderRight: '1px solid #ccc', py: 1 }}>
                              {exhibitor.booth_number}
                            </Typography>

                            {/* 出展者書類のステータス画像 */}
                            {getFilteredFields().map((field) => {
                              const { key, label, statusType, category } = field;
                              const exhibitorKey = `${key}_exhibitor_status`;
                              const hostKey = `${key}_host_status`;
                              const corporateKey = `${key}_corporate_status`;

                              const historyData = latestHistoryMap[exhibitor.exhibitor_id]?.[category];

                              let dateColor = "inherit";
                              let formattedDate = "";

                              if (historyData) {
                                const changedDate = new Date(historyData);
                                const now = new Date();
                                const diffDays = (now - changedDate) / (1000 * 60 * 60 * 24);

                                formattedDate = changedDate.toLocaleString("ja-JP", {
                                  month: "2-digit",
                                  day: "2-digit",
                                  hour: "2-digit",
                                  minute: "2-digit",
                                  hour12: false, // 24時間表記
                                });

                                // 提出後3日以内のみ赤色
                                if (diffDays <= 3) {
                                  dateColor = "rgb(255, 0, 0)";
                                }
                              }

                              // === 特殊処理: o5/o6 のホストステータス比較 ===
                              let displayHostStatus = exhibitor[hostKey];

                              if (key === 'o5') {
                                const o5 = exhibitor.o5_host_status;
                                const o6 = exhibitor.o6_host_status;

                                if (o5 === '申請しない' && (o6 === '未確認' || o6 === '確認済')) {
                                  displayHostStatus = o6; // o6優先
                                } else if (o5 === '申請しない' && o6 === '申請しない') {
                                  displayHostStatus = '申請しない';
                                } else {
                                  displayHostStatus = o5; // それ以外はo5そのまま
                                }
                              }

                              // candidates 作成
                              const candidates = [
                                exhibitor[exhibitorKey],
                                displayHostStatus,
                                exhibitor[corporateKey],
                              ].filter(Boolean);

                              // STATUS_PRIORITY で currentStatus を決定
                              const STATUS_PRIORITY = [
                                '再提出',
                                '未提出',
                                '未確認',
                                '確認中',
                                '1のみ確認済',
                                '2のみ確認済',
                                '確認済',
                                '申請しない',
                              ];

                              let currentStatus = '未提出';
                              for (const status of STATUS_PRIORITY) {
                                if (candidates.includes(status)) {
                                  currentStatus = status;
                                  break;
                                }
                              }

                              const imgSrc = getStatusImage(currentStatus);
                              const checkboxId = `${exhibitor.exhibitor_id}_${key}`;

                              return (
                                <Box
                                  key={key}
                                  sx={{
                                    width: 110,
                                    borderRight: '1px solid #ccc',
                                    py: 1,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    gap: 2,
                                  }}
                                >
                                  {formattedDate && (
                                    <Typography
                                      sx={{
                                        fontSize: 12,
                                        color: dateColor,
                                        textAlign: "center",
                                      }}
                                    >
                                      {formattedDate}
                                    </Typography>
                                  )}
                                  <img
                                    src={imgSrc}
                                    alt={`${label} ステータス`}
                                    className="max-61"
                                    onClick={
                                      currentStatus !== '申請しない' && !field.corporate
                                        ? () =>
                                            handleStatusClick(
                                              key,
                                              exhibitor.exhibitor_id,
                                              currentStatus,
                                              category
                                            )
                                        : field.corporate
                                        ? () => {
                                            setSelectedExhibitorId(exhibitor.exhibitor_id);
                                            setSelectedFormKey(key);
                                            setFormModalOpen(true);
                                          }
                                        : undefined
                                    }
                                    style={{
                                      cursor:
                                        currentStatus !== '申請しない' && !field.corporate
                                          ? 'pointer'
                                          : 'default',
                                      opacity: currentStatus === '申請しない' ? 0.6 : 1,
                                    }}
                                  />
                                  <input
                                    type="checkbox"
                                    checked={checkedPdfIds.includes(checkboxId)}
                                    onChange={() =>
                                      setCheckedPdfIds((prev) =>
                                        prev.includes(checkboxId)
                                          ? prev.filter((id) => id !== checkboxId)
                                          : [...prev, checkboxId]
                                      )
                                    }
                                    style={{ cursor: 'pointer' }}
                                  />
                                </Box>
                              );
                            })}
                            {/* モーダル */}
                            <Modal open={formModalOpen} onClose={() => setFormModalOpen(false)}>
                              <Box
                                sx={{
                                  p: 4,
                                  backgroundColor: 'white',
                                  width: '95%',
                                  margin: 'auto',
                                  mt: 10,
                                  maxHeight: '90vh',
                                  overflowY: 'auto',
                                  position: 'relative'
                                }}
                              >
                                {/* ×ボタン */}
                                <IconButton
                                  onClick={() => setFormModalOpen(false)}
                                  sx={{
                                    position: 'absolute',
                                    top: 8,
                                    right: 8,
                                  }}
                                >
                                  <CloseIcon />
                                </IconButton>
                                {renderForm(selectedFormKey, selectedExhibitorId)}
                              </Box>
                            </Modal>
                          </Box>
                        );
                      })}
                    </>
                  </Box>
                </Box>
              </Box>
              <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
                <Button
                  variant="outlined"
                  onClick={() => {
                    const newPage = Math.max(exhibitorPage - 1, 1);
                    setExhibitorPage(newPage);
                    setPageInput(newPage);
                  }}
                  disabled={exhibitorPage === 1}
                  sx={{ mx: 1 }}
                >
                  前へ
                </Button>
                <TextField
                  value={pageInput}
                  onChange={(e) => setPageInput(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handlePageChange();
                    }
                  }}
                  onWheel={(e) => e.target.blur()}
                  size="small"
                  type="number"
                  sx={{ width: 80, mx: 1 }}
                  inputProps={{
                    min: 1,
                    max: exhibitorTotalPages
                  }}
                />

                <Typography sx={{ mx: 1 }}>
                  / {exhibitorTotalPages}
                </Typography>
                <Button
                  variant="outlined"
                  onClick={() => {
                    const newPage =
                      exhibitorPage < exhibitorTotalPages ? exhibitorPage + 1 : exhibitorPage;
                    setExhibitorPage(newPage);
                    setPageInput(newPage);
                  }}
                  disabled={exhibitorPage >= exhibitorTotalPages}
                  sx={{ mx: 1 }}
                >
                  次へ
                </Button>
              </Box>

              <Modal open={mypageModalOpen} onClose={() => setMypageModalOpen(false)}>
                <Box
                  sx={{
                    p: 4,
                    backgroundColor: 'white',
                    width: '60%',
                    margin: 'auto',
                    mt: 10,
                    maxHeight: '80vh',
                    overflowY: 'auto',
                    borderRadius: 2,
                    position: 'relative'
                  }}
                >
                  {/* ×ボタン */}
                  <IconButton
                    onClick={() => setMypageModalOpen(false)}
                    sx={{
                      position: 'absolute',
                      top: 8,
                      right: 8,
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                  {mypageExhibitorId != null ? (
                    (() => {
                      const target = exhibitors.find(ex => ex.exhibitor_id === mypageExhibitorId);
                      if (!target) return <Typography>読み込み中...</Typography>;

                      return (
                        <Box>
                          <Typography variant="h6" sx={{ mb: 2 }}>マイページ情報</Typography>
                          <Typography>小間番号: {target.booth_number}</Typography>
                          <Typography>会社名: {target.company_name}</Typography>
                          <Typography>部署: {target.department}</Typography>
                          <Typography>担当者名: {target.user_name}</Typography>
                          <Typography>郵便番号: {target.zip_code}</Typography>
                          <Typography>住所: {target.address}</Typography>
                          <Typography>電話番号: {target.phone_number}</Typography>
                          <Typography>メールアドレス: {target.email}</Typography>
                        </Box>
                      );
                    })()
                  ) : (
                    <Typography>読み込み中...</Typography>
                  )}
                </Box>
              </Modal>

              {/* <Box sx={{ mt: 4 }} className="notice-box">
                <Box className='notice-title' sx={{ display: 'flex', justifyContent:'space-between', alignItems: 'center' }}>
                  <Typography variant="h6" className='title'>登録情報一覧</Typography>
                  <Box display="flex" justifyContent="flex-end" alignItems="center" gap={2} mb={0}>
                    <Button variant="contained" onClick={handleConfirmUpdate} disabled={checkedIds.length === 0}>
                      選択を「確認済」にする
                    </Button>
                    <Button variant="contained" onClick={handlePDFDownload} disabled={checkedPdfIds.length === 0}>
                      PDFダウンロード
                    </Button>
                  </Box>
                </Box>
                <Box padding={3}>
                  <Paper elevation={0} sx={{ p: 2, width: '100%', overflowX: 'auto' }}>
                    {renderTable()}
                  </Paper>
                </Box>
              </Box> */}

              {/* 必要ならここに申請ステータスや書類提出状況とか追加 */}
              <Box sx={{ mt: 6 }} className="notice-box" id="news">
                <Typography variant="h6" className='notice-title' gutterBottom>メッセナゴヤ事務局からのお知らせ</Typography>
                {notices
                  .filter((notice) => notice.visibility_setting !== '協力会社')
                  .map((notice, index) => (
                  <Box key={index} sx={{ mb: 2, p: 2 , display: 'flex', alignItems: 'center' }}>
                    <Box
                      sx={{
                        display: 'inline-block',
                        px: 2,
                        py: 0.5,
                        mb: 0,
                        mx: 0.5,
                        borderRadius: '4px',
                        backgroundColor:
                          notice.category === '緊急' ? '#c1272d' :
                          notice.category === '重要' ? '#f7931e' :
                          '#0071bc',
                        color: 'white',
                        fontWeight: 'bold',
                        fontSize: '20px'
                      }}
                    >
                      {notice.category}
                    </Box>
                    <Typography variant="h6" color="text.secondary" sx={{ mr: 2 }}>{notice.date}</Typography>
                    <Typography variant="h6">{notice.title}</Typography>
                    <Link to={`/news/${notice.notice_id}`} component={RouterLink} sx={{ mt: 1, display: 'block' }}>
                      　詳細を見る
                    </Link>
                  </Box>
                ))}

                {/* ページネーション */}
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                  {Array.from({ length: Math.ceil(totalN / noticesPerPage) }).map((_, idx) => (
                    <Button
                      key={idx}
                      onClick={() => handlePageChange(idx + 1)}
                      variant={page === idx + 1 ? 'contained' : 'outlined'}
                      sx={{ mx: 0.5 }}
                    >
                      {idx + 1}
                    </Button>
                  ))}
                </Box>
              </Box>
            </Container>
          </Container>
          <footer>
            <Typography>
              © 2026 THE MID-JAPAN ECONOMIST.
            </Typography>
          </footer>
        </div>
      );
    };

  export default ContractorMypage;

